<template>
    <div class="jump-order nav-bar-fixed">
        <van-nav-bar title="会员成就" left-arrow fixed
                     @click-left="back"
        />
        <div class="integral-header">
            <van-circle
                    v-model="currentRate"
                    :rate="100"
                    :speed="0"
                    color="#fff"
                    size="120px"
                    layer-color="#fff"
                    :stroke-width="60"
            >
                <div class="circle-text">
                    <p>{{integral}}</p>
                    <span>可用积分</span>
                </div>
            </van-circle>
        </div>
        <div class="integral-detail">
            <h5>总交易额</h5>
            <van-row>
                <van-col span="6">
                    目标金额
                </van-col>
                <van-col span="6">
                    赠送积分
                </van-col>
                <van-col span="6">
                    完成状态
                </van-col>
                <van-col span="6">

                </van-col>
            </van-row>

            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
            >

                <van-row class="integral-detail-item" v-for="item in list">
                    <van-col span="6">
                        {{item.targetMoney}}
                    </van-col>
                    <van-col span="6">
                        {{item.integral}}
                    </van-col>
                    <van-col span="6">
                        {{item.targetMoney>targetMoney?'未完成':'已完成'}}
                    </van-col>
                    <van-col span="6">
                        <a href="#/home">
                            <van-button type="primary" size="small">去下单</van-button>
                        </a>
                    </van-col>
                </van-row>
                <van-row>
                    去完善个人信息：<a href="#/user/info">
                    <van-button type="primary" size="small">去完善</van-button>
                </a>
                </van-row>
            </van-list>
        </div>
    </div>
</template>
<script>
    import {NavBar, Circle, Row, Col, List, Button} from "vant";

    export default {
        name: "userintegral",
        components: {
            [Button.name]: Button,
            [NavBar.name]: NavBar,
            [Circle.name]: Circle,
            [Row.name]: Row,
            [List.name]: List,
            [Col.name]: Col
        },
        data() {
            return {
                integral: "",
                currentRate: 0,
                list: [],
                loading: false,
                finished: false,
                total: 0,
                page: 1,
                targetMoney: 1000000000000
            };
        },
        mounted() {
            let that = this;
            this.$api.get(that.jumuc.userCenter.getUserInfo,
                null,
                successRes => {
                    // console.log(successRes)
                    if (successRes.success) {
                        that.integral = successRes.data.user.integral
                    }
                })
        },
        methods: {
            back() {
                history.back();
            }, onLoad() {
                let that = this
                // 异步更新数据
                that.$api.get(
                    that.jumuc.userCenter.getTargetMoney,
                    {"userId": localStorage.getItem("userId")},
                    successRes => {
                        let orderlist = successRes.data.configs
                        if (successRes.data.targetlog != null) {
                            that.targetMoney = successRes.data.targetlog.targetMoney
                        }
                        for (let i = 0; i < orderlist.length; i++) {
                            that.list.push(orderlist[i]);
                        }
                        // 加载状态结束
                        that.loading = false;
                        that.finished = true;
                    }
                )

            }
        }
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3c6eeb;
    body {
        background-color: #f7f7f7;
    }

    .van-hairline--bottom::after {
        border-width: 0px;
    }

    .jump-order {

        .integral-header {
            background-color: @bule-thame;
            text-align: center;
            padding: 20px 0 60px;
            position: relative;
            .circle-text {
                height: 120px;
                color: #fff;
                position: relative;
                p {
                    font-size: 26px;
                    line-height: 100px;
                }
                span {
                    position: absolute;
                    bottom: 30px;
                    left: 35px;
                    font-size: 14px;
                }
            }
        }
        .integral-detail {
            background-color: #fff;
            margin-top: 10px;
            padding: 10px 15px 20px;
            h5 {
                font-size: 16px;
                padding: 10px 0;
                border-bottom: 1px solid #ebedf0;
                color: #333;
            }
            &-item {
                border-bottom: 1px dashed #ebedf0;
                padding: 20px 0 10px;
                color: #ccc;
                p {
                    font-size: 16px;
                    color: #333;
                }
                .detail-num {
                    font-size: 20px;
                    &.add {
                        color: #f5a623;
                    }
                    &.plus {
                        color: #ccc;
                    }
                }
            }
        }
        .detail-no-more {
            text-align: center;
            padding: 10px;
            font-size: 14px;
            color: #ccc;
        }
    }
</style>


